import { useTranslation } from "react-i18next";
import PageLayout from "../components/PageLayout";
import SurveyCreator from "../components/SurveyCreator";
import styles from "./pages.module.css";

export default function CreateSurvey() {
    const { t } = useTranslation();
    return (
        <PageLayout>
            <section className={styles.section}>
                <h2 className={styles.title}>{t("createSurvey.title")}</h2>
                <SurveyCreator />
            </section>
        </PageLayout>
    );
}
